<template>
  <div>
    <nav class="navbar container navbar-expand-lg navbar-light" >
      <a class="navbar-brand d-none d-md-block" href="#">
        <img class="" style="width:20%;" src="static/img/logoBiologicas.jpeg" alt="">
        Facultad de Ciencias Biológicas
      </a>
      <a
        class="navbar-brand d-none d-md-block ml-auto"
        href=""
        v-on:click.prevent="Login">
        UANL
      </a>
      <a class="navbar-brand d-block d-md-none" href="#">
        <img class="" style="width:25%;" src="static/img/logoBiologicas.jpeg" alt="">
        FCB UANL
      </a>
    </nav>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      opcion_activa:'Login'
    }
  },
  methods:{
    Login(){
      this.opcion_activa='Login';
      this.$router.push({name:'Login'});
    }
  },
  created(){
    if (this.$route.name=='MenuPrincipal') {
      this.Login();
    }else{
      this.$router.push({name:this.$route.name});
    }
  }
};
</script>

<style scoped>
li.active{
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPrincipal.vue